import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class HeaderService1 {
    constructor(private http: HttpClient) { }

    getHeaderService() {
        return this.http.get<any[]>(`${environment.apiUrl}header`);
    }    
	
     
}